import "react-international-phone/style.css";

import {
  BaseTextFieldProps,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import {
  CountryIso2,
  defaultCountries,
  FlagImage,
  parseCountry,
  usePhoneInput,
} from "react-international-phone";
import { useTranslations } from "next-intl";

export interface MUIPhoneProps extends BaseTextFieldProps {
  value: string;
  defaultCountry: string;
  onChange: (phone: string, country: string) => void;
}

export const PhoneInput: React.FC<MUIPhoneProps> = ({
  value,
  defaultCountry,
  onChange,
  ...restProps
}: MUIPhoneProps) => {
  const countries = defaultCountries.filter((country) => {
    const { iso2 } = parseCountry(country);
    return ["az", /* "kz",  */ "ua"].includes(iso2);
  });

  const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
    defaultCountry: defaultCountry.toLowerCase(),
    value,
    countries,
    onChange: (data) => {
      onChange(data.phone, data.country.iso2);
    },
  });

  const t = useTranslations("AuthModal");

  return (
    <TextField
      variant="outlined"
      label={t("phone")}
      color="primary"
      placeholder={t("phone")}
      value={inputValue}
      onChange={handlePhoneValueChange}
      type="tel"
      inputRef={inputRef}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start" style={{ marginRight: "2px", marginLeft: "-8px" }}>
              <Select
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: "300px",
                      // maxWidth: "330px",
                      width: {
                        xs: "100%",
                        sm: "330px",
                      },
                      mt: "5px",
                      ml: {
                        xs: "0",
                        sm: "-34px",
                      },
                      background: "var(--global-bg-color)",
                    },
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                }}
                sx={{
                  width: "max-content",
                  fieldset: {
                    display: "none",
                  },
                  '&.Mui-focused:has(div[aria-expanded="false"])': {
                    fieldset: {
                      display: "block",
                    },
                  },
                  ".MuiSelect-select": {
                    padding: "8px",
                    paddingRight: "24px !important",
                  },
                  svg: {
                    right: 0,
                  },
                }}
                value={country.iso2}
                onChange={(e) => setCountry(e.target.value as CountryIso2)}
                renderValue={(valuePhone) => (
                  <FlagImage iso2={valuePhone} style={{ display: "flex" }} />
                )}
              >
                {countries.map((c) => {
                  const countryData = parseCountry(c);
                  return (
                    <MenuItem key={countryData.iso2} value={countryData.iso2}>
                      <FlagImage iso2={countryData.iso2} style={{ marginRight: "8px" }} />
                      <Typography color="white" marginRight="8px">
                        {countryData.name}
                      </Typography>
                      <Typography color="gray">+{countryData.dialCode}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </InputAdornment>
          ),
        },
      }}
      {...restProps}
    />
  );
};
